import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { withPanel } from '../operate-types';

/** Open «¿Por qué?» (`?panel=porque`), dropping any other panel's deep-link params. */
export function useOpenWhy(): () => void {
  const [, setParams] = useSearchParams();
  return useCallback(() => setParams((prev) => withPanel(prev, 'porque')), [setParams]);
}
